var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { RequerimentoProvider } from './context/RequerimentoContext';
import { RequerimentoCadastro } from './RequerimentoCadastro';
import React from 'react';
export var RequerimentoCadastroRoot = function () {
    return (_jsx(RequerimentoProvider, { children: _jsx(RequerimentoCadastro, {}) }));
};
export var filterRenderChecklist = function (checklist) {
    var _a;
    if (checklist) {
        var _sessoes = ((_a = checklist === null || checklist === void 0 ? void 0 : checklist.sessoes) === null || _a === void 0 ? void 0 : _a.map(function (sessao, indexSessao) {
            var _a;
            var _itens = ((_a = sessao === null || sessao === void 0 ? void 0 : sessao.itens) === null || _a === void 0 ? void 0 : _a.map(function (sessaoItem, indexItem) {
                var _a;
                if ((sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.visible) || ((_a = ((sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.anexos) || [])) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return sessaoItem;
                }
                return undefined;
            }).filter(function (it) { return !!it; })) || [];
            if (_itens.length > 0) {
                return __assign(__assign({}, sessao), { itens: _itens });
            }
            return undefined;
        }).filter(function (it) { return !!it; })) || [];
        return __assign(__assign({}, checklist), { sessoes: __spreadArray([], _sessoes, true) });
    }
    else {
        return null;
    }
};
